<template>
    <DsModal
        class="copy-from-automation-sequence-modal"
        is-open
        show-close
        :title="$t('funnel.edit.sequence.copyFromCampaign.modal.title')"
        @close="closeModal"
    >
        <template #header>
            <DsFilledButton
                data-qa="save-button"
                :disabled="!selectedAutomation || !selectedSequence"
                @click="handleSave"
            >
                {{ $t('funnel.edit.save') }}
            </DsFilledButton>
        </template>
        <template #default>
            <div class="configuration-content">
                <DsInlineAlert
                    data-qa="critical-alert"
                    type="critical"
                    leading-icon
                >
                    {{ $t('funnel.edit.sequence.copyFromCampaign.modal.overwriteWarning') }}
                </DsInlineAlert>
                <div class="section-header">
                    {{ $t('funnel.edit.sequence.copyFromCampaign.modal.summary.header') }}
                </div>
                <div class="section-details">
                    {{ $t('funnel.edit.sequence.copyFromCampaign.modal.summary.details') }}
                </div>
                <DsMultiselect
                    v-model="selectedAutomation"
                    class="automation-select"
                    value-prop="id"
                    label-prop="displayName"
                    :options="automations"
                    :placeholder="$t('funnel.edit.sequence.copyFromCampaign.modal.automation.placeholder')"
                    data-qa="selected-automation"
                    searchable
                    required
                />
                <template v-if="selectedAutomation">
                    <DsMultiselect
                        v-if="!!sequences.length"
                        v-model="selectedSequence"
                        class="sequence-select"
                        value-prop="id"
                        label-prop="name"
                        :options="sequences"
                        :placeholder="$t('funnel.edit.sequence.copyFromCampaign.modal.sequence.placeholder')"
                        data-qa="selected-sequence"
                        searchable
                        required
                    />
                    <DsInlineAlert v-else type="warning">
                        {{ $t('funnel.edit.sequence.copyFromCampaign.modal.sequence.warning.noSequences') }}
                    </DsInlineAlert>
                </template>
            </div>
        </template>
    </DsModal>
</template>

<script>
import axios from 'axios';
import { FLOW_TYPE } from '../../utils/editor.constants';
import { mapCampaignXmlToJson } from '../../utils/cell/automation-mapper-utils';

export default {

    emits: ['replace-sequence', 'close-modal'],

    data() {
        return {
            automations: [],
            sequences: [],
            selectedAutomation: null,
            selectedAutomationJson: null,
            selectedSequence: null,
        };
    },

    watch: {
        selectedAutomation: {
            handler(selection) {
                if (selection) this.onSelectedAutomation(selection.id);
            },
        },
    },

    mounted() {
        this.fetchAutomations();
    },

    methods: {
        async onSelectedAutomation(id) {
            const selectedAutomationXml = (await axios.get(`/app/funnel/${id}/xml`)).data;

            this.selectedAutomationJson = await mapCampaignXmlToJson(selectedAutomationXml);

            const sequences = this.selectedAutomationJson.cells.filter((cell) => cell.type === FLOW_TYPE);

            this.sequences = sequences.map((sequence) => {
                return {
                    ...sequence,
                    name: sequence?.value?.name,
                };
            });
        },

        async fetchAutomations() {
            const { data } = await axios.get('/app/funnel/listAllCampaigns');

            this.automations = data.map(({ displayName, id }) => {
                return { displayName, id };
            });
        },

        async handleSave() {
            this.$emit('replace-sequence', { otherJson: this.selectedAutomationJson, otherSequenceId: this.selectedSequence.id });

            this.closeModal();
        },

        closeModal() {
            this.$emit('close-modal');
        },
    },
};

</script>

<style lang="scss" scoped>

.configuration-content {
    display: grid;
    grid-gap: $spacing-150;
}
.section-header {
    font-size: $font-size-xs;
    line-height: $line-height-sm;
}
.section-details {
    font-size: $font-size-md;
    line-height: $line-height-lg;
}
</style>

<style lang="scss">
// reset padding - css leak
.copy-from-automation-sequence-modal .modal-body {
    padding: unset;
}

</style>
